import {PAYMENT_CODES, VALIDATION_OPTIONS} from '../payment-codes-enum';

export default function PaymentCodesContainerService() {
    Object.assign(this, {
        isPerTravellerCheckboxVisible,
        reinitializeModel,
        processPaymentCodes,
    });

    const MIN_ADULTS_TO_ALLOW_PER_TRAVELLER_CODES = 2;

    function isPerTravellerCheckboxVisible(tripDetails) {
        const {HasPaymentCodesPerTraveller, Travelers} = tripDetails;
        const adultsCount = Travelers && Travelers.Adult.length;
        return adultsCount >= MIN_ADULTS_TO_ALLOW_PER_TRAVELLER_CODES
            && HasPaymentCodesPerTraveller;
    }

    function reinitializeModel(isPerTravellerCheckboxChecked = false, tripDetails) {
        if (!tripDetails) {
            return [];
        }

        const {PaymentCodes = [], Travelers: {Adult = []}} = tripDetails;
        return isPerTravellerCheckboxChecked && Adult.length >= MIN_ADULTS_TO_ALLOW_PER_TRAVELLER_CODES
            ? initPaymentCodesModelPerTraveller(PaymentCodes, Adult)
            : initPaymentCodesModelForOneTraveller(undefined, PaymentCodes);
    }

    function initPaymentCodesModelPerTraveller(codes, travellers) {
        if (!codes || !travellers) {
            return [];
        }

        return travellers.map((traveller) => {
            const withTravellerId = initPaymentCodesModelForOneTraveller.bind(null, traveller.Id);
            return withTravellerId(codes);
        });
    }

    function initPaymentCodesModelForOneTraveller(travellerId, codes) {
        const filtered = codes.filter((code) => !code.ParentPaymentCodeId);
        const result = filtered.map((code) => {
            switch (code.PaymentCodeFieldTypeId) {
                case PAYMENT_CODES.PREDEFINED_DROPDOWN:
                    return {
                        travellerId,
                        PaymentCodeFieldTypeId: code.PaymentCodeFieldTypeId,
                        Id: code.Id,
                        value: getInitialValue(code),
                        isDropdown: isDropdown(code),
                    };
                case PAYMENT_CODES.MASK_DROPDOWN:
                    return [{
                        value: code.Mask,
                        Id: code.Id,
                        PaymentCodeFieldTypeId: code.PaymentCodeFieldTypeId,
                    }, {
                        value: getInitialValue(code),
                        Id: code.Id,
                        PaymentCodeFieldTypeId: code.PaymentCodeFieldTypeId,
                        isDropdown: isDropdown(code),
                    }];
                case PAYMENT_CODES.DROPDOWN_MASK:
                    return [{
                        value: getInitialValue(code),
                        Id: code.Id,
                        PaymentCodeFieldTypeId: code.PaymentCodeFieldTypeId,
                        isDropdown: isDropdown(code),
                    }, {
                        value: code.Mask,
                        Id: code.Id,
                        PaymentCodeFieldTypeId: code.PaymentCodeFieldTypeId,
                    }];
                case PAYMENT_CODES.HIERARCHICAL_CODES:
                    return {
                        travellerId,
                        PaymentCodeFieldTypeId: code.PaymentCodeFieldTypeId,
                        organisation: {
                            Value: '',
                            Id: code.Id,
                            CustomerLabel: code.CustomerLabel,
                        },
                        project: {
                            Value: '',
                            Id: null,
                        },
                        taskCode: null,
                        awardCode: null,
                    };
                default:
                    return {
                        travellerId,
                        PaymentCodeFieldTypeId: code.PaymentCodeFieldTypeId,
                        Id: code.Id,
                        value: code.CodeValue || code.PresetValue,
                    };
            }
        });

        return result;
    }

    function getInitialValue(code) {
        const selectedValue = code.DropDownValues.find((value) => value === code.CodeValue || value === code.PresetValue);
        return selectedValue
            ? {text: selectedValue, value: selectedValue}
            : {text: '---', value: ''};
    }

    function processPaymentCodes(paymentCodes) {
        const {PREDEFINED_DROPDOWN, MASK_DROPDOWN, DROPDOWN_MASK} = PAYMENT_CODES;
        const paymentCodeIdsWithDropdownValues = [PREDEFINED_DROPDOWN, MASK_DROPDOWN, DROPDOWN_MASK];

        return paymentCodes.map((code) => {
            return paymentCodeIdsWithDropdownValues.includes(code.PaymentCodeFieldTypeId)
                ? addFormattedDropdownValues(code)
                : code;
        });
    }

    function addFormattedDropdownValues(code) {
        const paymentCode = {...code, DropDownValues: formatDropdownValues(code.DropDownValues)};
        paymentCode.DropDownValues.unshift({text: '---', value: ''});
        Object.assign(paymentCode, {isDropdown: isDropdown(code)});
        return paymentCode;
    }

    function formatDropdownValues(dropdownValues) {
        return dropdownValues.map((value) => {
            return {
                text: value,
                value,
            };
        });
    }

    function isDropdown(code) {
        return code.PaymentCodeValidationOption === VALIDATION_OPTIONS.DISPLAY_AS_DROPDOWN;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-container/payment-codes-container-service.js